export default __webpack_public_path__ + "static/media/background.2e754f1d.jpeg";